import { useServicesContext } from "@modules/core/services/services.context"
import { ProgramInfiniteTypeOf } from "@modules/programs/programInfiniteTypes"
import { ProgramOnOffTypeOf } from "@modules/programs/programOnOffTypes"
import { useQuery } from "@tanstack/react-query"

export const useDetailedProgramSession = (
  id: string,
  sessionDate?: string,
  programId?: string,
  programType?: typeof ProgramInfiniteTypeOf | typeof ProgramOnOffTypeOf,
) => {
  const { programInfiniteSessionApi, programOnOffSessionApi } = useServicesContext()

  const { data, refetch, isLoading } = useQuery({
    queryKey: ["programSession", id, programId, programType, sessionDate],
    queryFn: async () => {
      if (programType === ProgramInfiniteTypeOf) return await programInfiniteSessionApi.getDetailedSession(id)
      else if (programType === ProgramOnOffTypeOf && programId)
        return await programOnOffSessionApi.getDetailedSession(id, programId, sessionDate)
    },
  })

  return {
    data,
    isLoading,
    refetch,
  }
}
